// All data fetching for this page lives in src/helpers/externalApiOverview.js,
// externalApiStats.js, externalApiInsights.js and externalApiLogs.js (shared
// with the client's own API tabs), so this route carries no api1/onLoad action
// of its own - RouteComponent still expects an `api` object, it is just empty.
export default {};
